import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth.service';
import { AppConstants } from 'src/app/config.service';

@Component({
  templateUrl: './unauthorised-page.component.html',
  styleUrls: ['./unauthorised-page.component.scss']
})

export class UnauthorizedPageComponent implements OnInit , OnDestroy{
  constructor(
    private appConstants: AppConstants,
    private authService: AuthService,
    private router: Router
  ) {}

  isTenantUserIdAvailable: boolean = false;
  isRoleAvailable: boolean = false;
  isLoader: boolean = true;
  subscription : Subscription
  ngOnInit() {
   this.subscription = this.appConstants.setupLoader.subscribe((res) => {
      this.isLoader = res;
    });
    this.checkUserAccess();
  }

  ngOnDestroy() {
    if(this.subscription) this.subscription.unsubscribe();
  }

  async checkUserAccess() {
    await this.appConstants.checkTenantUserId();
    this.isTenantUserIdAvailable =
      this.appConstants.tenantUserId && this.appConstants.tenantUserId.length
        ? true
        : false;
    this.isRoleAvailable = await this.authService.checkRoleExist(
      'trutesta-testplans'
    );

    if (this.isTenantUserIdAvailable && this.isRoleAvailable)
      this.router.navigate(['/test-plans'])
  }
}
